<template>

    <div class="container">
        <div class="row">
            <!-- <div class="col-3">
            </div> -->
            <div class="col-12">
                <div class="card mb-0">
                    <form name="tokenform" id="tokenform">
                        <iframe id="tokenFrame" name="tokenFrame" :src="src" scrolling="no" width="500" height="500" frameborder="0">
                            <input type="hidden" name="mytoken" id="mytoken"/>
                        </iframe>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        order_id : {
            type: String,
            required: false,
        }
    },
    data() {
        return {
            iframesrc : 'http://2150dfw.qwik-order.com:10080/card-connect?formatinput=true&invalidinputevent=true&autofocus=true&enhancedresponse=true&cardinputmaxlength=20&maskfirsttwo=true',
            kuid : null,
        }
    },

    computed: {
        src() {
            return this.iframesrc + '&kuid=' + this.kuid;
        }
    },

    created() {
        // this.kuid = this.order_id;
        this.kuid = '0215046601A624C1AF96BBC001';
    }
    
}
</script>

<style scoped>
    iframe, form{
        /* border: 1px solid red; */
        width: 100%;
        height: 100%;
    }
    .container, .row {
        height: 750px;
    }
    .card { 
        height: 100%;
    }
</style>
